import React from "react";

import { Box, FocusTrap, Popover } from "@mantine/core";
import { useDisclosure, useClickOutside } from "@mantine/hooks";

import { useIsSmallerThan } from "ui/theme/helpers";

import { useScrollLock } from "./hooks/use-scroll-lock";

interface MobileAwareDropdownProps {
  renderButton: (onClick?: () => void) => JSX.Element;
  renderContent: () => JSX.Element;
}

export function MobileAwareDropdown({
  renderButton,
  renderContent,
}: MobileAwareDropdownProps): JSX.Element {
  const [opened, { close, open }] = useDisclosure(false);
  const [_scrollLocked, setScrollLocked] = useScrollLock();
  const ref = useClickOutside(() => {
    close();
    setScrollLocked(false);
  });

  const isSmallScreen = useIsSmallerThan("sm");

  if (isSmallScreen) {
    return (
      <div style={{ position: "relative" }}>
        {renderButton(() => {
          if (opened) {
            close();
            setScrollLocked(false);
          } else {
            open();
            setScrollLocked(true);
          }
        })}
        <Box
          ref={ref}
          sx={{
            position: "fixed",
            left: 0,
            right: 0,
            zIndex: 100,
          }}
        >
          {opened && <FocusTrap>{renderContent()}</FocusTrap>}
        </Box>
      </div>
    );
  } else {
    return (
      <Popover
        trapFocus
        styles={{
          dropdown: {
            padding: 0,
            minWidth: "300px",
            marginLeft: 10,
            zIndex: 100,
          },
        }}
      >
        <Popover.Target>
          <Box>
            {" "}
            {/* I don't know why but this container is necessary to make the popover work properly */}
            {renderButton()}
          </Box>
        </Popover.Target>
        <Popover.Dropdown>{renderContent()}</Popover.Dropdown>
      </Popover>
    );
  }
}
